module.exports = __webpack_public_path__ + "img/AstroFrens12.68abf2fd.jpg";